import React from 'react';
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"
import { Container } from '@pixi/react';
import { utils } from '../../utils'

class PixiGamePlayerRow extends React.Component
{

  getMeepleSpriteByColourID( colourID )
  {
    return "./ui/Meeple Counter Filled - " + utils.capitalizeFirstLetter( colourID ) + ".png";
  }

  render()
  {
    const stageRenderData = this.props.stageRenderData;
    const score = this.props.playerScore;
    const isClientPlayerRow = this.props.isClientPlayerRow;
    const isCurrentPlayerTurn = this.props.isCurrentPlayerTurn;
    const teamColourID = this.props.teamColourID;

    let meeplesStates = [];
    let xOffset = 99;
    let yOffset = isClientPlayerRow ? 60 : 44;

    for( let idx = 0; idx < 7; idx++ )
    {
      let meepleSprite = idx < this.props.playerMeeples.length
        ? this.getMeepleSpriteByColourID( teamColourID )
        : "ui/Meeple Empty Slot.png";

      meeplesStates.push(

        <PixiScaledSprite
          key={ idx.toString() }
          imageSrc={ meepleSprite }
          stageRenderData={ stageRenderData }
          x={ this.props.x - ( this.props.width - xOffset ) * stageRenderData.scale }
          y={ this.props.y - yOffset }
          width={ 38 }
          height={ 38 }
          anchor={ { x: 0.5, y: 0.5 } } />
      );

      xOffset += 30;
    }


    return (

      <Container>
        <PixiScaledSprite
          imageSrc={ "./ui/panel_bg.png" }
          isNineSlice={ true }
          tint={ isCurrentPlayerTurn ? 0xDEE8E5 : 0x9DA2A0 }
          stageRenderData={ stageRenderData }
          x={ this.props.x }
          y={ this.props.y }
          width={ this.props.width }
          height={ this.props.height }
          anchor={ { x: 1, y: 1 } }
          onClick={ () => { this.props.onClickedAction() } } />

        { isClientPlayerRow &&
          <>

            <PixiScaledText
              text={ this.props.playerName }
              stageRenderData={ stageRenderData }
              x={ this.props.x - ( this.props.width / 2.0 ) * stageRenderData.scale }
              y={ this.props.y - ( this.props.height / 2 ) - 32 }
              anchor={ { x: 0.5, y: 0.5 } }
              fontSize={ 16 }
              style={ this.props.textStyle }
            />

            <PixiScaledSprite
              imageSrc={ this.props.playerIconSprite }
              stageRenderData={ stageRenderData }
              x={ this.props.x - ( this.props.width - 49 ) * stageRenderData.scale }
              y={ this.props.y - ( this.props.height - 48 ) }
              width={ 50 }
              height={ 50 }
              anchor={ { x: 0.5, y: 0.5 } }
            />

            <PixiScaledText
              text={ score }
              stageRenderData={ stageRenderData }
              x={ this.props.x - ( this.props.width - 49 ) * stageRenderData.scale }
              y={ this.props.y - 32 }
              anchor={ { x: 0.5, y: 0.5 } }
              style={ this.props.textStyle }
              fontSize={ 15 }
            />

          </>
        }

        { !isClientPlayerRow &&
          <>
            <PixiScaledText
              text={ this.props.playerName }
              stageRenderData={ stageRenderData }
              x={ this.props.x - ( this.props.width - 48 ) * stageRenderData.scale }
              y={ this.props.y - ( this.props.height / 2 ) - 30 }
              anchor={ { x: 0.5, y: 0.5 } }
              fontSize={ 12 }
              style={ this.props.textStyle }
            />

            <PixiScaledSprite
              imageSrc={ this.props.playerIconSprite }
              stageRenderData={ stageRenderData }
              x={ this.props.x - ( this.props.width - 48 ) * stageRenderData.scale }
              y={ this.props.y - ( this.props.height - 38 ) }
              width={ 33 }
              height={ 33 }
              anchor={ { x: 0.5, y: 0.5 } }
            />

            <PixiScaledText
              text={ score }
              stageRenderData={ stageRenderData }
              x={ this.props.x - ( this.props.width - 49 ) * stageRenderData.scale }
              y={ this.props.y - 20 }
              anchor={ { x: 0.5, y: 0.5 } }
              style={ this.props.textStyle }
              fontSize={ 13 }
            />
          </>
        }

        { meeplesStates }

      </Container>

    );
  }
}

export default PixiGamePlayerRow;
